import {Input} from "@heroui/react"

interface SearchBarProps {
  searchTerm: string
  onSearchChange: (value: string) => void
}

const SearchBar = ({searchTerm, onSearchChange}: SearchBarProps) => {
  return (
    <div className="w-full">
      <Input
        classNames={{
          base: "w-full",
          inputWrapper: "border-2 border-blue-500",
        }}
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        endContent={
          searchTerm && (
            <button
              className="focus:outline-none"
              onClick={() => onSearchChange("")}
            >
              ×
            </button>
          )
        }
      />
      <p className="font-regular mb-2 ml-[0.375rem] mt-[0.125rem] select-none text-[8px]">
        {/* Search by name, phone number, email, or type a prompt and Quartz will */}
        {/* find examples of it (i.e. "Report of occurances where converations */}
        {/* clearly are missing context signalling conversation off channel") */}
        Search by name, phone number, or email and Quartz will find examples of
        it
      </p>
    </div>
  )
}

export default SearchBar
